import PropTypes from "prop-types";
import classnames from "classnames";

import { CONTACT_US_EMAIL as contactEmail } from "../../constants";

import "./noResultsFound.scss";

const NoResultsFound = ({ searchKeyword, className }) => {
  const classes = classnames("no-results-found", className);
  return (
    <div className={classes}>
      <div className="no-results-found__content">
        <p className="main-text">
          Sorry, we didn't find any matches for "{searchKeyword}".
        </p>
        <p className="sub-text">
          Please try searching with another keyword, or if you have questions,
          please <a href={`mailto:${contactEmail}`}>contact us</a>.
        </p>
      </div>
    </div>
  );
};

NoResultsFound.propTypes = {
  searchKeyword: PropTypes.string,
};

NoResultsFound.defaultProps = {
  searchKeyword: "",
};

export default NoResultsFound;
